// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".innerBorder[data-v-70b980f2] {\n  border: 2px solid #ffffff;\n}\n.customChat[data-v-70b980f2], .customHo[data-v-70b980f2] {\n  height: 46px;\n  width: 46px;\n}\n.customModal[data-v-70b980f2] {\n  width: 22px;\n  height: 22px;\n}\n@media screen and (max-width: 640px) {\n.customHo[data-v-70b980f2] {\n    height: 28px;\n    width: 28px;\n}\n}\n.customH[data-v-70b980f2] {\n  height: 46px;\n  width: 46px;\n}", ""]);
// Exports
module.exports = exports;
